module.exports = __webpack_public_path__ + "static/media/redpagos.78c506cf.png";